import { ResultsView } from '@kijiji/generated/graphql-types'
import { GridIcon, ListingStackIcon, MapPinLocationIcon } from '@kijiji/icons/src/icons'
import { theme } from '@kijiji/theme'
import { useTranslation } from 'next-i18next'
import { useMemo } from 'react'

import { TRANSLATION_KEYS } from '@/constants/localization'
import {
  SrpViewTextLinkButton,
  ViewButtonStyles,
  ViewButtonText,
  ViewFlexContainer,
} from '@/features/map/components/srp-view-button/styled'

export type ViewButtonProps = {
  onClick: (type: ResultsView) => void
  type: ResultsView
  isSrpControlsMwebToggleEnabled?: boolean
}

export const SRPViewButton = ({
  onClick,
  type,
  isSrpControlsMwebToggleEnabled,
}: ViewButtonProps) => {
  const { t } = useTranslation(TRANSLATION_KEYS.SRP)

  const Icon = useMemo(() => {
    switch (type) {
      case ResultsView.Map:
        return <MapPinLocationIcon size="xsm" aria-hidden="true" />
      case ResultsView.List:
        return <ListingStackIcon size="xsm" aria-hidden="true" />
      case ResultsView.Grid:
        return <GridIcon size="xsm" aria-hidden="true" />
      default:
        return null
    }
  }, [type])

  const handleClick = () => {
    onClick(type)
  }

  const ctaLabel = t(`srp:view_button.${type.toLocaleLowerCase()}`)

  if (isSrpControlsMwebToggleEnabled) {
    return (
      <SrpViewTextLinkButton onClick={handleClick} variant="secondary" size="small">
        {Icon}
        {ctaLabel}
      </SrpViewTextLinkButton>
    )
  }

  return (
    <ViewButtonStyles
      shape="pill"
      size="compact"
      type="button"
      onClick={handleClick}
      variant="subtle"
      data-testid="toggle-button"
    >
      <ViewFlexContainer
        justifyContent="space-around"
        alignItems="center"
        gap={theme.spacing.mini}
        flexGrow={1}
      >
        {Icon}
        <ViewButtonText>{ctaLabel}</ViewButtonText>
      </ViewFlexContainer>
    </ViewButtonStyles>
  )
}
